import axios from "axios";

tinymce.PluginManager.add('abbr', function (editor, url) {
	let abbrArr = []
	const pageSize = 100
	const uri = window.origin.includes('local')? 'https://new-www.local.oooinex.ru' : `${window.origin}`

	async function addAbbrDecode() {
		await initAbbr()

		abbrArr = []
	}

	async function initAbbr() {
		await getAbbrDict()

		let abbrObj = formatAbbrDict()
		console.log(abbrObj)

		findAbbr(abbrObj)
	}

	async function getAbbrDict(curPage = 1) {
		await axios.get(`${uri}/api/arm/107/1866301/data?&page=${curPage}&pageSize=${pageSize}`).then(async ({data}) => {
			abbrArr = [ ...abbrArr, ...data.records]

			if (curPage < Math.ceil(data.count / pageSize)) {
				await getAbbrDict(++curPage)
			}
		}).catch(error => {
			console.error(error.response)
		})
	}

	function formatAbbrDict() {
		return abbrArr.reduce((obj, el) => {
			const name = el.fields.find(item => item.fieldId === 'abbr').value
			const value = el.fields.find(item => item.fieldId === 'name').value

			if (!obj[name]) {
				obj[name] = value
				return obj
			}

			if (Array.isArray(obj[name])) {
				obj[name] = obj[name].concat(value)
				return obj
			}

			obj[name] = [obj[name]]
			obj[name].push(value)
			return obj

		}, {})
	}

	function findAbbr(abbrObj) {
		const content = editor.getContent()

		for (let key in abbrObj) {
			const abbrPositions = getPositions(key, content)
			const regex = new RegExp(String.raw`(?<!\p{L}\p{M}*|[\p{N}_])${key}(?![\p{L}\p{N}_])`, 'u');

			if (regex.test(content) && abbrPositions.length) {

				if (Array.isArray(abbrObj[key])) {
					const listboxValues = abbrObj[key].map((el) => ({text: el, value: el}))

					editor.windowManager.open({
						title: `Выберите определение аббревиатуры "${key}"`,
						width: 700,
						height: 400,
						body: [{
							type: 'listbox',
							name: 'popupSelect',
							label: 'Выбор',
							values: listboxValues,
							onselect: function (listObj) {
								replaceAbbr(key, listObj.control.settings.value)
								editor.windowManager.close()
							}
						}],
						onsubmit: function (e) {
							replaceAbbr(key, e.data.popupSelect)
						}
					})
				} else {
					replaceAbbr(key, abbrObj[key])
				}
			}
		}
	}

	function replaceAbbr(abbr, text){
		const content = editor.getContent()
		const abbrPositions = getPositions(abbr, content)

		let start = 0
		let newContent = ''

		abbrPositions.forEach((abbrPosition) => {
			newContent += content.substring(start, abbrPosition)
			newContent += `<abbr title="${text}">${abbr}</abbr>`

			start = abbrPosition + abbr.length
		})

		newContent += content.substring(start, content.length)

		editor.setContent(newContent);
	}

	function getPositions(abbr, content) {
		const regex = new RegExp(String.raw`(?<!\p{L}\p{M}*|[\p{N}_])${abbr}(?![\p{L}\p{N}_])`, 'u');
		let abbrPositions = []
		let pos = -1
		while ((pos = content.indexOf(abbr, pos + 1)) !== -1) {
			if (
				regex.test(content.substring(pos-4, pos+abbr.length+4)) &&
				content.substring(pos-4, pos+abbr.length) !== `id="${abbr}` &&
				content.substring(pos, pos+abbr.length+6) !== `${abbr}</abbr`
			) {
				abbrPositions.push(pos)
			}
		}

		return abbrPositions
	}

	editor.addButton('abbr', {
		text: 'А',
		tooltip: 'Проверить аббревиатуры',
		onclick: addAbbrDecode,
	});

	editor.addMenuItem('abbr', {
		text: 'А',
		tooltip: 'Проверить аббревиатуры',
		onclick: addAbbrDecode,
		context: 'insert',
		prependToContext: true
	});
});
